(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-search-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-mobile-search]');
    if (!drawer) return;

    var overlay = document.querySelector('[data-mobile-search-overlay]');
    var closeButton = drawer.querySelector('[data-mobile-search-close]');
    var input = drawer.querySelector('[data-mobile-search-input]');
    var results = drawer.querySelector('[data-mobile-search-results]');
    var debounceTimer;

    function open() {
      drawer.classList.add('mobile-search-drawer--open');
      overlay.classList.add('mobile-search-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      input.focus();
    }

    function close() {
      drawer.classList.remove('mobile-search-drawer--open');
      overlay.classList.remove('mobile-search-overlay--visible');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mobile-search-open]')) {
        event.preventDefault();
        open();
        return;
      }

      if (event.target.closest('[data-mobile-search-close]')) {
        close();
        return;
      }

      if (overlay && event.target === overlay) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('mobile-search-drawer--open')) {
        close();
      }
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch(
          '/search/suggest.json?q=' +
            encodeURIComponent(query) +
            '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last'
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            renderResults(data.resources.results.products);
          })
          .catch(function () {
            results.hidden = true;
          });
      }, 300);
    });

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    function renderResults(products) {
      if (!products.length) {
        results.innerHTML = '<p class="mobile-search-drawer__empty">' + escapeHtml(drawer.dataset.noResults) + '</p>';
        results.hidden = false;
        return;
      }

      results.innerHTML = products
        .map(function (product) {
          var image = product.image
            ? '<img src="' +
              product.image +
              '&width=96" alt="" class="mobile-search-drawer__result-image" width="48" height="48" loading="lazy">'
            : '';

          return (
            '<a href="' +
            product.url +
            '" class="mobile-search-drawer__result">' +
            image +
            '<span class="mobile-search-drawer__result-info">' +
            '<span class="mobile-search-drawer__result-title">' +
            escapeHtml(product.title) +
            '</span>' +
            '<span class="mobile-search-drawer__result-price">$' +
            escapeHtml(product.price) +
            '</span>' +
            '</span>' +
            '</a>'
          );
        })
        .join('');
      results.hidden = false;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var elements = document.querySelectorAll('[data-reveal]');

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
